import { ActionTaken, ReportResponseType } from '@utils-global';

export type ReportResultScreen = 'legacy' | 'interacted' | 'verdict';

type SelectReportResultScreenArgs = {
  isV2: boolean;
  reportType: ReportResponseType;
  actionsTaken: ActionTaken[];
};

export const selectReportResultScreen = ({
  isV2,
  reportType,
  actionsTaken,
}: SelectReportResultScreenArgs): ReportResultScreen => {
  if (!isV2) return 'legacy';

  if (reportType === ReportResponseType.SIMULATION) return 'verdict';

  if (actionsTaken.length > 0) return 'interacted';

  return 'verdict';
};
